"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareListingUrl = void 0;
const prepareListingUrl = _ref => {
  let {
    deviceType,
    newbuildings,
    baseUrlDesktop,
    baseUrlMobile
  } = _ref;
  if (newbuildings.length < 5) {
    return undefined;
  }
  const newobjectParams = newbuildings.map((_ref2, index) => {
    let {
      id
    } = _ref2;
    return `newobject[${index}]=${id}`;
  }).join('&');
  return `${deviceType === 'desktop' ? baseUrlDesktop : baseUrlMobile}&${newobjectParams}`;
};
exports.prepareListingUrl = prepareListingUrl;